import { inject } from 'vue'
export const ResetHashView = (to: any, from: any) => {
  const getQueryParameter = inject('getQueryParameter') as (paramName: string) => string
  if (!getQueryParameter('key')) {
    return { name: 'LoginView' }
  }
}
